module.exports = __webpack_public_path__ + "img/EASTASIA_ANIMAL_FATS.653ae675.png";